import { FC } from 'react'
import NextImage from 'next/image'

import { Section } from 'components/section'
import { Heading } from 'components/heading'
import { Markdown } from 'components/markdown'
import { LinkButton } from 'components/links'
import { routes } from 'utils/routes'

import bgImage from './bg.png'
import classes from './join-section.module.css'

interface JoinSectionProps {
  title: string
  content: string
}

export const JoinSection: FC<JoinSectionProps> = ({ content, title }) => {
  return (
    <div className={classes.container}>
      <Section className={classes.section}>
        <div>
          <Heading theme="h2">{title}</Heading>
          <Markdown className={classes.content}>{content}</Markdown>
          <LinkButton theme="accentLinkToMobileBtn" href={routes.joinUs}>
            view openings
          </LinkButton>
        </div>
        <div>
          <div className={classes.imageContainer}>
            <NextImage
              src={bgImage}
              width={534}
              height={301}
              sizes="50vw"
              alt="Team people"
              className={classes.image}
            />
          </div>
        </div>
      </Section>
    </div>
  )
}
